import type { SlotPropsOverrides } from '@unifyapps/defs/blocks/TemplateComponent/types';
import type { BlockStateUnionType, BlockType } from '@unifyapps/defs/types/block';
import type BlocksRegistry from '../../../context/RegistryProvider/BlocksRegistry';
import type { GlobalStateStore } from '../types';
import { mergeBlockOverride } from './mergeBlockOverride';

export function getInitialBlockState({
  blocks,
  registry,
  componentOverrides,
}: {
  blocks: Record<string, BlockType>;
  registry: BlocksRegistry;
  componentOverrides?: SlotPropsOverrides;
}) {
  const result: GlobalStateStore['blocks'] = {};
  const blockKeys = Object.keys(blocks);
  const blockKeysLength = blockKeys.length;

  for (let i = 0; i < blockKeysLength; i++) {
    const key = blockKeys[i];
    // merge override deltas (if any) onto the authored block before computing
    // its initial state — this avoids a second-pass update + re-render path
    const block = mergeBlockOverride(blocks[key], componentOverrides?.[key]);

    const componentType = block.component.componentType;
    const initialState = registry.getBlockInitialState(componentType, block);
    result[key] = (initialState ?? {}) as BlockStateUnionType;
  }

  return result;
}
